import { render } from "./App.vue?vue&type=template&id=361a5632"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script